import * as React from 'react'
import { FormItem } from 'uiComponents/form/formElements'
import { TextArea } from 'uiComponents/input'
import { CancelRefundNotesProps } from '../types'
import './styles.scss'
import { useTranslation } from 'translations'

const CancelRefundNotes = (props: CancelRefundNotesProps) => {
    const { t } = useTranslation()
    const { cancelRefundReason, handleTextAreaChange, isCancellation } = props

    return (
        <FormItem className="cancel-refund-notes" htmlFor="request">
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <p className="body1 noMargin">{t('orders.orders.cancelAndRefund.notes.label')}</p>
                <p className="body1 noMargin secondary">{t('orders.orders.cancelAndRefund.notes.optional')}</p>
            </div>
            <TextArea
                className="text-area"
                maxLength={4000}
                placeholder={
                    isCancellation
                        ? t('orders.orders.cancelAndRefund.notes.cancellationPlaceholder')
                        : t('orders.orders.cancelAndRefund.notes.refundPlaceholder')
                }
                value={cancelRefundReason ? cancelRefundReason : ''}
                onChange={handleTextAreaChange}
            />
        </FormItem>
    )
}

export default CancelRefundNotes
